import React, { useState, useEffect } from "react";
import { Icon } from "Components/atoms/Icon";
import { NavMenu } from "Components/molecules/NavMenu";
import { menuItems } from "shared/config/menuItemsConfig";
import { theme } from "styles/theme";
import { AUTH_SERVER_URL, startLogin } from "shared/auth/auth";
import { useAuth } from "shared/contexts/AuthContext";
// @ts-ignore
import { ReactComponent as LogoVoopter } from "assets/svgs/logo-voopter.svg";
// @ts-ignore
import { ReactComponent as ProfileIcon } from "assets/svgs/profile.svg";
import {
  HeaderWrapperMobile,
  LogoWrapperMobile,
  MobileHeaderActions,
  MobileLoginAction,
  MenuListWrapperMobile,
  MobileMenuToggleMobile,
  MobileNavWrapperMobile,
  MobileProfileAction,
} from "./styles";
import { useGeneralContext } from "shared/contexts/GeneralContext";
import { sendGTMEvent } from "shared/services/GTM";
import { getPlatformType } from "shared/utils/platform";

export const HeaderMobile: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { isHeaderVisible, setIsHeaderVisible } = useGeneralContext();
  const { isAuthenticated, status } = useAuth();

  const handleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY === 0) {
        setIsHeaderVisible(true);
      } else {
        setIsHeaderVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [setIsHeaderVisible]);

  return (
    <HeaderWrapperMobile isVisible={isHeaderVisible}>
      <div>
        <LogoWrapperMobile href="/" aria-label="Ir para a página inicial">
          <LogoVoopter />
        </LogoWrapperMobile>
        <MobileHeaderActions>
          {status !== "loading" &&
            (isAuthenticated ? (
              <MobileProfileAction
                to="/dados-pessoais"
                aria-label="Minha Conta"
                onClick={() =>
                  sendGTMEvent("accountAccess", {
                    platform: getPlatformType(),
                    source: "header_mobile",
                    section: "personal",
                  })
                }
              >
                <ProfileIcon aria-hidden="true" />
              </MobileProfileAction>
            ) : (
              <MobileLoginAction
                href={AUTH_SERVER_URL}
                onClick={(event) => {
                  event.preventDefault();
                  startLogin({ source: "header" });
                }}
              >
                Entrar
              </MobileLoginAction>
            ))}

          <MobileMenuToggleMobile
            type="button"
            onClick={handleMenu}
            aria-label={isMenuOpen ? "Fechar menu" : "Abrir menu"}
            aria-expanded={isMenuOpen}
          >
            <Icon
              color={theme.colors.mediumBlue}
              name={isMenuOpen ? "FaTimes" : "FaBars"}
              size="large"
              library="fa"
              label="Menu Icon"
            />
          </MobileMenuToggleMobile>
        </MobileHeaderActions>
      </div>

      {isMenuOpen && (
        <MobileNavWrapperMobile>
          <MenuListWrapperMobile>
            <NavMenu
              items={menuItems.map((item) => ({
                label: item.label,
                action: () => {
                  item.action();
                  setIsMenuOpen(false);
                },
              }))}
            />
          </MenuListWrapperMobile>
        </MobileNavWrapperMobile>
      )}
    </HeaderWrapperMobile>
  );
};
